import { FC } from 'react'

export type StepActionFile = {
  id: string
  filename: string
  // Mirrors DocumentsDocument.contentType, which is nullable in the schema.
  contentType?: string | null
  fileUrl: string
}

export type StepActionContentProps = {
  taskId: string
  // The EmployeeLifecycle::StepAction id — distinct from the inbox task id.
  // Present for every step-action taskable; optional only because the
  // taskable can be undefined while the activity query is in flight.
  stepActionId?: string
  files?: StepActionFile[]
}

export type StepActionContentComponent = FC<StepActionContentProps>

export type ActionType = 'basic_task' | 'training' | 'upload_document'

export const parseConfigurationJson = (
  json: string | null | undefined
): Record<string, unknown> | null => {
  if (!json) return null

  try {
    const parsed: unknown = JSON.parse(json)

    if (typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed)) {
      const record: Record<string, unknown> = { ...parsed }
      return record
    }

    return null
  } catch {
    return null
  }
}
